import { tickerNews } from "@/mocks/homeNews";

export default function BreakingBar() {
  const loop = [...tickerNews, ...tickerNews];
  return (
    <div className="bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-stretch overflow-hidden ticker-hover">
          <div className="flex items-center gap-2 shrink-0 z-10 pr-3 bg-primary-600 text-background-50">
            <span className="relative flex h-full items-center px-3">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-blink" />
              <span className="ml-2 text-xs font-bold tracking-widest whitespace-nowrap">实时快讯</span>
            </span>
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker items-center py-2.5">
              {loop.map((n, i) => (
                <span key={i} className="flex items-center whitespace-nowrap">
                  <span className="px-5 text-sm text-foreground-800">{n}</span>
                  <span className="text-primary-400 text-[10px]">●</span>
                </span>
              ))}
            </div>
          </div>
          <div className="hidden md:flex items-center gap-2 pl-3 shrink-0 text-foreground-600">
            <i className="ri-radar-line w-5 h-5 flex items-center justify-center text-primary-600" />
            <span className="text-xs font-medium whitespace-nowrap">盯梢中 · 随时更新</span>
          </div>
        </div>
      </div>
    </div>
  );
}